import { gql } from "@apollo/client";

const ENTRY_FIELDS = `
  id
  source
  username
  tokens
  itemName
  message
  status
  priority
  addedBy
  bankedBy
  bankedAt
  completedBy
  completedAt
  createdAt
`;

export const GET_TIP_QUEUE = gql`
  query getTipQueue($broadcaster: String) {
    getTipQueue(broadcaster: $broadcaster) {
      menuItems {
        name
        amount
      }
      waiting {
        ${ENTRY_FIELDS}
      }
      banked {
        ${ENTRY_FIELDS}
      }
      done {
        ${ENTRY_FIELDS}
      }
      notes {
        ${ENTRY_FIELDS}
      }
    }
  }
`;

export const GET_MY_TIP_QUEUE = gql`
  query getMyTipQueue {
    getMyTipQueue {
      waiting {
        ${ENTRY_FIELDS}
      }
      banked {
        ${ENTRY_FIELDS}
      }
    }
  }
`;

export const SEARCH_CB_TIPPERS = gql`
  query searchCbTippers($query: String!) {
    searchCbTippers(query: $query)
  }
`;

export const ADD_MANUAL_TIP = gql`
  mutation addManualTip($input: AddManualTipInput!) {
    addManualTip(input: $input) {
      ${ENTRY_FIELDS}
    }
  }
`;

export const ADD_MANUAL_TIPS = gql`
  mutation addManualTips($inputs: [AddManualTipInput!]!) {
    addManualTips(inputs: $inputs) {
      added {
        ${ENTRY_FIELDS}
      }
      errors {
        index
        message
      }
    }
  }
`;

export const SET_TIP_QUEUE_STATUS = gql`
  mutation setTipQueueStatus($id: ID!, $status: String!) {
    setTipQueueStatus(id: $id, status: $status) {
      ${ENTRY_FIELDS}
    }
  }
`;

export const REORDER_TIP_QUEUE = gql`
  mutation reorderTipQueue($lane: String!, $ids: [ID!]!) {
    reorderTipQueue(lane: $lane, ids: $ids)
  }
`;
